import React, { useState, useEffect } from 'react';
import { Eye, EyeOff, Lock, User, Loader2 } from 'lucide-react';
import { clearSession, permissionEnabled, saveSessionPermissions } from './lib/session-permissions';

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [secureMode, setSecureMode] = useState(true);
  const base_url = process.env.REACT_APP_API_URL || 'http://localhost:5008';

  useEffect(() => {
    const savedUser = localStorage.getItem('@last_user');
    if (savedUser) setUsername(savedUser);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert('Preencha todos os campos.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${base_url}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      if (!response.ok) {
        let message;
        if (response.status === 401) message = 'Usuário ou senha inválidos.';
        else if (response.status === 429) {
          const seconds = Number(response.headers?.get('Retry-After'));
          message = Number.isFinite(seconds) && seconds > 0
            ? 'Muitas tentativas de login. Aguarde ' + Math.ceil(seconds) + ' segundos e tente novamente.'
            : 'Muitas tentativas de login. Aguarde e tente novamente.';
        } else if (response.status >= 500) message = 'O servidor está indisponível no momento. Tente novamente em instantes.';
        else if (response.status === 403) message = 'Usuário sem permissão de Acesso';
        else if (response.status === 400) message = 'Verifique o usuário e a senha informados.';
        else message = 'Não foi possível entrar no sistema. Tente novamente.';
        if (response.status === 403) clearSession();
        alert(message);
        return;
      }
      const data = await response.json();
      if (typeof data?.token !== 'string' || !data.token.trim()) {
        alert('Resposta inválida do servidor. Não foi possível iniciar a sessão.');
        return;
      }

      if (!permissionEnabled(data.utilizaBordo)) {
        clearSession();
        alert('Usuário sem permissão de Acesso');
        return;
      }

      if (response.ok) {
        // Armazena o token e o usuário para persistência
        localStorage.setItem('@user_token', data.token);
        localStorage.setItem('@last_user', username);
        saveSessionPermissions(data);
        localStorage.setItem('@NomeUsuario', data.nomeUsuario);


        onLoginSuccess();
      }
    } catch (error) {
      console.error("Erro no login:", error);
      alert('Falha na conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#161b22] border border-gray-800 rounded-xl p-8 shadow-2xl">
        <div className="flex flex-col items-center mb-8">
          <img
            //src="https://suprasoft.net/imagens/logo-erp-supramais.png" 
            src="https://fck.ind.br/wp-content/uploads/2025/05/logo-fck-premoldados.webp"
           
           //src="https://suprasoft.net/includes/img/logo-supra-site-footer.png"
           //src="https://suprasoft.net/includes/img/logo-supra-site.png"
           //src="https://www.padua.ind.br/imagens/superior_logo.jpg"
           //src="https://static.wixstatic.com/media/f866a4_2496e71bfb3246e6bc51f37a5f670165~mv2.png/v1/fill/w_190,h_176,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/logo-rodape.png"
           //src="https://static.wixstatic.com/media/f866a4_07cf19dc1191429198d329fc490fc648~mv2.png/v1/fill/w_166,h_159,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/logo.png"
           alt="Logo"
            className="w-28 h-auto mb-2 opacity-50"
          />
          <h2 className="text-white text-[10px] tracking-[0.5em] uppercase font-black opacity-80">
            Acesso Restrito
          </h2>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-[10px] uppercase font-bold text-gray-500 mb-1 ml-1">Usuário</label>
            <div className="relative">
              <User className="absolute left-3 top-3.5 text-gray-600" size={18} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-[#0d1117] border border-gray-800 rounded-lg py-3 pl-10 pr-4 text-white focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="Digite seu usuário"
              />
            </div>
          </div>

          <div>
            <label className="block text-[10px] uppercase font-bold text-gray-500 mb-1 ml-1">Senha</label>
            <div className="relative">
              <Lock className="absolute left-3 top-3.5 text-gray-600" size={18} />
              <input
                type={secureMode ? "password" : "text"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0d1117] border border-gray-800 rounded-lg py-3 pl-10 pr-12 text-white focus:outline-none focus:border-blue-500 transition-colors"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setSecureMode(!secureMode)}
                className="absolute right-3 top-3.5 text-gray-600 hover:text-gray-400"
              >
                {secureMode ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-lg transition-all flex items-center justify-center gap-2 mt-4 disabled:opacity-50"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "ENTRAR NO SISTEMA"}
          </button>
        </form>
      </div>
    </div>
  );
}
